import { SwalDialogService } from 'src/app/core/shared/services/swal-dialog.service';
import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SharedModule } from 'src/app/core/shared/shared.module';
import {
  CommonTableComponent,
  QueryParamsModel,
  TableColumn
} from 'src/app/layouts/components/common-table/common-table.component';
import { QuotationService } from '../quotation.service';
import { UserAuthenticationService } from 'src/app/core/navigation/user-authentication.service';
import { firstValueFrom, Subject, Subscription, takeUntil } from 'rxjs';
import { ProgramConfigService } from '../../master-data/program-config/program-config.service';
import { AddQuotationComponent } from '../add-quotation/add-quotation.component';
import { ListRefreshService } from 'src/app/service/list-refresh/list-refresh.service';
import { DataService } from '../../home/program-license-agreement-process/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewPdfComponent } from '../../master-data/program-config/components/view-pdf/view-pdf.component';
import { AddPoNumberComponent } from '../add-po-number/add-po-number.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'vex-quotation-list',
  standalone: true,
  imports: [
    CommonTableComponent,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule
  ],
  templateUrl: './quotation-list.component.html',
  styleUrls: ['./quotation-list.component.scss']
})
export class QuotationListComponent {
  @ViewChild('cnTable', { static: true })
  commonTableRef!: CommonTableComponent;
  public actions: Array<any> = [];
  public burgerActions: Array<any> = [];
  public columns: TableColumn<any>[] = [];
  filter: any = {};
  programList: any[] = [];

  @Input() showProgramFilter: boolean = true;
  @Input() programDetails: any;
  userInfo: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  private subscription: Subscription;
  private isComponentInitialized: boolean = false;
  programConfigId: any;
  companyId: any;
  queryParamsQuat: any;
  paymentColumns: any;
  paymentActions: any;
  quatPONumber: string;
  crumbs: any = '';

  badgeFilterItems = [
    { value: 'all', link: '/program/payments', name: 'Payments' },
    {
      value: 'quotations',
      link: '/program/quotation',
      name: 'Quotations'
    }
  ];
  queryParamsPay: any;
  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
    public appSettingsService: AppSettingsService,
    private quotationService: QuotationService,
    public userCheck: UserAuthenticationService,
    private programConfigService: ProgramConfigService,
    private listRefreshService: ListRefreshService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private _router: Router,
    private checkUser: UserAuthenticationService,
    private swalDialogService: SwalDialogService
  ) {}

  async ngOnInit() {
    this.companyId = this.route.snapshot.queryParams['companyId'];

    const CQAColumn: any = [
      { label: 'ID', property: 'id', type: 'text', visible: false },
      {
        label: 'Company Name',
        property: 'CompanyName',
        type: 'text',
        visible: true
      },
      {
        label: 'Company Number',
        property: 'companyNumber',
        type: 'text',
        visible: true
      },
      {
        label: 'Date Quotation Requested',
        property: 'DateQuotationRequested',
        type: 'text',
        visible: true
      },
      {
        label: 'Date Quotation Sent',
        property: 'DateQuotationSent',
        type: 'text',
        visible: true
      },
      {
        label: 'Actions',
        property: 'actions',
        type: 'button',
        visible: true
      }
    ];
    const companyColumn: any = [
      { label: 'ID', property: 'id', type: 'text', visible: false },
      {
        label: 'Company Name',
        property: 'CompanyName',
        type: 'text',
        visible: true
      },
      {
        label: 'Company Number',
        property: 'companyNumber',
        type: 'text',
        visible: true
      },
      {
        label: 'Date Quotation Requested',
        property: 'DateQuotationRequested',
        type: 'text',
        visible: true
      },
      {
        label: 'Date Quotation Sent',
        property: 'DateQuotationSent',
        type: 'text',
        visible: true
      },
      {
        label: 'Actions',
        property: 'actions',
        type: 'button',
        visible: true
      }
    ];
    if (this.userCheck.checkUser()) {
      this.columns.push(...CQAColumn);
    } else {
      this.columns.push(...companyColumn);
    }
    this.isComponentInitialized = true;
    this.userInfo = this.appSettingsService.userData().userDetails;
    this.actions = [
      {
        key: 'viewFile',
        property: 'quotationForm',
        label: 'View Quotation'
      }
    ];

    if (!this.checkUser.checkUser()) {
      this.burgerActions = [
        { key: 'quatPONumber', icon: 'mat:edit', label: 'Update PO Number' },
        { key: 'quatCart', icon: 'mat:shopping_basket', label: 'Checkout' }
      ];
    }

    // if (this.userCheck.checkUser()) {
    //   this.columns.splice(1, 0, {
    //     label: 'Company Name',
    //     property: 'companyName',
    //     type: 'text',
    //     visible: true
    //   });
    // }

    this.getPrograms();
    this.listRefreshService
      .getListObservable()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res) => {
        if (res) {
          this.commonTableRef.initLoadItems();
        }
      });
    //subscribe program value selected
    this.subscription = this.dataService.program$.subscribe((res: any) => {
      if (res) {
        this.programConfigId = res?.id;
        if (!this.isComponentInitialized) {
          // Only call if the component is not initializing
          this.commonTableRef.initLoadItems();
        }

        // After initial setup, set the flag to false
        this.isComponentInitialized = false;
      }
    });

    if (this.userCheck.checkUser()) {
      this.crumbs = '';
    } else {
      this.crumbs = { label: 'Dashboard', path: '/program/dashboard' };
    }
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  currentProgram: any;
  isLoading: boolean = false;
  async init() {
    try {
      this.currentProgram = await firstValueFrom(
        this.dataService.getUserData()
      );
      if (this.currentProgram) {
        this.programConfigId = this.currentProgram?.id;
      }
      this.inItFilterOptions();
    } catch {}
  }

  inItFilterOptions() {
    this.filter.where = {
      programConfigId: this.programConfigId,
      companyId: !this.userCheck.checkUser()
        ? this.userInfo.company.id
        : this.companyId
        ? this.companyId
        : null
    };
  }
  async getPrograms() {
    let resp: any = await firstValueFrom(
      this.programConfigService.getProgramConfigAll()
    );
    this.programList = resp.items;
  }
  /**
   * onLoadItemsEvent
   */
  public async onLoadItemsEvent(queryParams: QueryParamsModel) {
    await this.init();
    if (this.userCheck.checkUser()) {
      this.showProgramFilter = this.showProgramFilter;
      this.filter.where = {
        programConfigId: this.programDetails?.id
          ? this.programDetails?.id
          : null,
        ...this.filter.where
      };
    } else {
      this.showProgramFilter = true;
      this.filter.where = {
        ...this.filter.where,
        companyId: this.userInfo?.company ? this.userInfo?.company.id : null
      };
    }
    if (Object.keys(this.filter).length) {
      queryParams.filter = JSON.stringify(this.filter);
    }
    this.quotationService.getQuotationList(queryParams).subscribe((resp) => {
      this.commonTableRef.loadItems(resp);
    });
  }

  onAddClick() {
    let dialogRef: MatDialogRef<AddQuotationComponent>;
    dialogRef = this.dialog.open(AddQuotationComponent, {
      data: {
        programDetails: this.programDetails
      },
      width: '40%'
    });

    dialogRef.afterClosed().subscribe((resp) => {
      if (resp) {
        this.commonTableRef.initLoadItems();
      }
    });
  }
  // onActionClickEmit(ev: any) {
  //   console.log(ev);
  //   let key = ev.action.key;
  //   switch (key) {
  //     case 'edit':
  //       this.onEditUOM(ev.data);
  //       break;
  //     case 'delete':
  //       this.onDeleteUOM(ev.data.id);
  //       break;
  //     default:
  //       break;
  //   }
  // }

  // onEditUOM(data: any) {
  //   let dialogRef: MatDialogRef<UomEditComponent>;
  //   dialogRef = this.dialog.open(UomEditComponent, {
  //     data: {
  //       uom: data
  //     },
  //     autoFocus: false,
  //     width: '40%'
  //   });

  //   dialogRef.afterClosed().subscribe((resp) => {
  //     if (resp) {
  //       this.commonTableRef.initLoadItems();
  //     }
  //   });
  // }
  // onAddClick() {
  //   let dialogRef: MatDialogRef<UomEditComponent>;
  //   dialogRef = this.dialog.open(UomEditComponent, {
  //     width: '40%'
  //   });

  //   dialogRef.afterClosed().subscribe((resp) => {
  //     if (resp) {
  //       this.commonTableRef.initLoadItems();
  //     }
  //   });
  // }

  // onDeleteUOM(id: any) {
  //   if (!id) return false;

  //   this.appSettingsService
  //     .confirm('Delete', 'Are you sure you want to delete?')
  //     .then((res) => {
  //       if (res) {
  //         this.UOMService.deleteUOM(id).subscribe((resp: any) => {
  //           if (resp && resp.status) {
  //             this.toastr.success(`${resp.data}`);
  //             this.commonTableRef.initLoadItems();
  //           }
  //         });
  //       }
  //     });
  // }
  applyFilter(filterKey: string, value: any): void {
    if (value) {
      this.filter.where[filterKey] = value;
    } else {
      delete this.filter.where[filterKey];
    }
    let filterTimeout: any;
    if (filterTimeout) {
      clearTimeout(filterTimeout);
    }
    filterTimeout = setTimeout(() => {
      this.commonTableRef.initLoadItems();
    }, 300);
  }
  onChangeProgram(ev: any) {
    this.applyFilter('programConfigId', ev?.id);
  }
  onActionClickEmit(ev: any) {
    let key = ev.action.key;
    switch (key) {
      case 'edit':
        this.onEditFormType(ev.data);
        break;
      case 'delete':
        this.onDeleteFormType(ev.data.id);
        break;
      case 'file':
        this.viewFileData(ev?.data?.invoiceForm);
        break;
      case 'quatPONumber':
        this.onCallPONumber(ev?.data);
        break;
      case 'quatCart':
        if (ev.data.isAgreementQuo) {
          this._router.navigate(['/home', 1], {
            queryParams: {
              quotationNumber: ev.data.id,
              programConfigId: this.programConfigId
            }
          });
        } else {
          this._router.navigate(['/checkout'], {
            queryParams: { quotationNumber: ev.data.id }
          });

          this.dataService.setCheckoutDataSignal({
            quotationNumber: ev.data.id
          });
        }

        break;

      default:
        break;
    }
  }
  onEditFormType(data: any) {}

  onDeleteFormType(id: any) {
    if (!id) return false;

    this.appSettingsService
      .confirm('Delete', 'Are you sure you want to delete?')
      .then((res) => {
        if (res) {
          // this.paymentService.deleteDomain(id).subscribe((resp: any) => {
          //   if (resp && resp.status) {
          //     this.toastr.success(`${resp.data}`);
          //     this.commonTableRef.initLoadItems();
          //   }
          // });
        }
      });
  }
  viewFileData(ev: any) {
    let dialogRef: MatDialogRef<ViewPdfComponent>;
    dialogRef = this.dialog.open(ViewPdfComponent, {
      width: '80%',
      data: {
        src: ev
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {});
  }
  async onCallPONumber(ev: any) {
    let id = ev.id;
    let dialogRef: MatDialogRef<AddPoNumberComponent>;
    dialogRef = this.dialog.open(AddPoNumberComponent, {
      data: ev,
      autoFocus: false,
      width: '40%'
    });

    dialogRef.afterClosed().subscribe(async (resp) => {
      if (resp) {
        let data: any = {
          PONumber: resp.PONumber
        };
        try {
          await firstValueFrom(this.quotationService.updateQuotation(id, data));
          this.swalDialogService.showMessage({
            title: 'PO number updated successfully'
          });
          this.commonTableRef.initLoadItems();
        } catch (err) {
          this.appSettingsService.handleError(err);
        }
      }
    });
  }
}
